import React from 'react';
import PropTypes from 'prop-types';
import FormField from './../FormField';
import DropdownField from './../DropdownField';
import RemovableRow from './../RemovableRow';
import { Button } from 'reactstrap';
import styles from './LinkFieldset.scss';
import { MobileMediaQuery, DesktopMediaQuery } from '../../MediaQueries';
import classnames from 'classnames';
import find from 'lodash/find';

const LinkFieldset = ({ member, index, fields, urlTypes, onSetAsPrimary, formErrors, lockedType }) => {
  const currentField = fields.get(index);
  const isPrimary = currentField.is_primary;

  const checkLockingPattern = (n) => n.type && n.type.name === lockedType;
  let isLocked = checkLockingPattern(currentField);

  if (isLocked) {
    const last = find(fields.getAll(), checkLockingPattern);
    isLocked = last.url === currentField.url;
  }

  const trimSpaces = value => {
    return value.replace(/\s/g, '');
  }

  const typeProps = {
    name: `${member}.type`,
    component: DropdownField,
    inputProps: { valueField: 'id', textField: 'name', disabled: isLocked },
    error: formErrors.getIn(['links', index.toString(), 'type']),
    data: urlTypes,
    type: 'text',
    className: 'form-control',
    placeholder: 'Select a URL Type',
    required: true
  };

  const urlProps = {
    name: `${member}.url`,
    error: formErrors.getIn(['links', index.toString(), 'url']),
    component: 'input',
    inputProps: { disabled: isLocked },
    type: 'text',
    className: 'form-control',
    placeholder: 'http://',
    required: true,
    normalize: trimSpaces,
  };

  return (
    <RemovableRow
      className={classnames({ [styles.primaryLink] : isPrimary }, styles.row)}
      fields={fields}
      index={index}
      addonsOnHover={false}
      isLocked={isLocked}
    >
      <div className="col-12 col-lg-3">
        <MobileMediaQuery>
          <FormField label="Type" {...typeProps}/>
        </MobileMediaQuery>
        <DesktopMediaQuery>
          <FormField {...typeProps}/>
        </DesktopMediaQuery>
      </div>
      <div className="col-lg-5">
        <MobileMediaQuery>
          <FormField label="URL Address" {...urlProps} />
        </MobileMediaQuery>
        <DesktopMediaQuery>
          <FormField {...urlProps} />
        </DesktopMediaQuery>
      </div>
      <div className={isPrimary ? 'col' : 'col visible-on-hover'}>
        {isPrimary ?
          <div>
            <h4 className="mb-0">Primary</h4>
            <span className="text-muted">This is the most important URL you want us to drive traffic to.</span>
          </div>
          :
          <Button
            size="sm"
            onClick={() => onSetAsPrimary(index)}
          >
            Set as Primary
          </Button>
        }
      </div>
    </RemovableRow>
  );
};

LinkFieldset.propTypes = {
  formErrors: PropTypes.object,
  member: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  fields: PropTypes.object.isRequired,
  urlTypes: PropTypes.array.isRequired,
  onSetAsPrimary: PropTypes.func.isRequired,
  lockedType: PropTypes.string,
};

LinkFieldset.defaultPros = {
  lockedType: null,
}

export default LinkFieldset;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/LinkFieldset.jsx